import OpenAI from "openai";
import { IoMdReturnLeft } from "react-icons/io";

export const GenerateInternalLinks = async ({
  targetUrl = "",
  keywords = "",
  supportingArticles = [],
  primaryKeyword = "",
  secondaryKeywords = [],
  targetAudience = "",
  l4pk = "",
  l4sk = "",
  outputFormatRequest = `| Priority | Source Article | Anchor Text | Exact Placement | Updated Paragraph |\n|----------|----------------|-------------|------------------|-------------------|\nnote: please use url in source article field.`,
  instructions = `Please extract real paragraphs or section headings from the supporting articles (do not invent headings). Insert the anchor text naturally into existing content or append a short new paragraph if necessary. Prioritize relevance and natural flow.`,
  apiKey = process.env.REACT_APP_OPENAI_API_KEY,
  model = "gpt-4.1",
}) => {
  // Helper: build query
  const buildFinalQuery = () => {
    let sections = [];

    if (targetUrl.trim()) {
      sections.push(`**Target URL:** ${targetUrl.trim()}`);
    }

    if (typeof keywords === "string" && keywords.trim()) {
      const keywordsArray = keywords
        .split("\n")
        .map((k) => k.trim())
        .filter((k) => k.length > 0);

      sections.push(`**Target Keywords:** [${keywordsArray.join(", ")}]`);
    }

    if (primaryKeyword.trim()) {
      sections.push(`**Primary Keyword:** ${primaryKeyword.trim()}`);
    }

    if (Array.isArray(secondaryKeywords) && secondaryKeywords.length > 0) {
      sections.push(
        `**Secondary Keywords:** [${secondaryKeywords
          .map((k) => k.trim())
          .filter(Boolean)
          .join(", ")}]`
      );
    }

    if (targetAudience.trim()) {
      sections.push(`**Target Audience:** ${targetAudience.trim()}`);
    }

    if (supportingArticles.length > 0) {
      const articlesList = supportingArticles
        .map((a) => {
          // If it's an object with .url, use that
          const val = typeof a === "string" ? a : a?.url || "";
          return "- " + val.trim();
        })
        .filter((line) => line.trim().length > 2) // remove empty entries
        .join("\n");

      if (articlesList) {
        sections.push(`**Supporting Articles:**  \n${articlesList}`);
      }
    }

    let linkDistribution = [];
    if (l4pk !== "" && !isNaN(l4pk)) {
      linkDistribution.push(`**Primary Links:** ${l4pk}`);
    }
    if (l4sk !== "" && !isNaN(l4sk)) {
      linkDistribution.push(`**Secondary Links:** ${l4sk}`);
    }
    if (linkDistribution.length > 0) {
      sections.push(`# Link Distribution:\n${linkDistribution.join("  \n")}`);
    }

    if (outputFormatRequest.trim()) {
      sections.push(`# Output Format Request:\n${outputFormatRequest.trim()}`);
    }

    if (instructions.trim()) {
      sections.push(`# Instructions:\n${instructions.trim()}`);
    }

    return `# Internal Linking Brief\n${sections.join("\n\n")}\n`;
  };

  // MAIN EXECUTION
  if (!apiKey || !model) {
    throw new Error("API Key and Model are required.");
  }

  const query = buildFinalQuery();

  console.log("link suggestion prompt", query);

  try {
    const openai = new OpenAI({ apiKey, dangerouslyAllowBrowser: true });
    const response = await openai.responses.create({
      model,
      input: query,
    });

    const outputText = response.output_text || "No output from AI.";
    console.log(outputText);
    // const updatedPosts = parseAndAssociateLinkSuggestions(outputText);

    // return { outputText, updatedPosts };
    return outputText;
  } catch (error) {
    throw new Error("Error generating article: " + error.message);
  }
};
